module.exports = __webpack_public_path__ + "catalog/items/rectangular-block/rectangular-block.svg";